import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const ValidateCpf = (cpf, setIsValid) => {
    if (!cpf) {
        setIsValid(true);
        return;
    }

    axios.post(`${API_URL}/validator/cpf`, {cpf})
        .then(() => setIsValid(true))
        .catch(() => setIsValid(false));
};

export default ValidateCpf;